<div class="container">

    <header class="text-center mb-4">
        <h3 mat-dialog-title class="title">
            Vos prochaines courses
        </h3>
    </header>


    <mat-dialog-content class="map-container">
        <div class="map-frame">
            <div id="map"></div>
        </div>
    </mat-dialog-content>

</div>